export default {
    pageTitle: 'Thank you for your registration! | Test account',
    title: 'Thank you for your registration!',
    content1: 'We are glad that you would like to test the Trendmanager. Take the chance to convince yourself of the advantages and functions. For this purpose, the account will be available to you for the next 72 hours.',
    content2: 'You have received an e-mail from us.<br />Please only confirm your registration by clicking on the link and then set your individual password.'
}
